import { shouldForwardPrimitiveProp as e } from "./primitiveProps.mjs";
import { Box as t } from "./Box.mjs";
import { styled as n } from "styled-components";
//#region src/components/Primitives/Flex.tsx
var r = n(t).withConfig({ shouldForwardProp: e })`
    display: ${({ inline: e }) => e ? "inline-flex" : "flex"};
    flex-direction: ${({ direction: e }) => e ?? "row"};
    align-items: ${({ align: e }) => e ?? "stretch"};
    justify-content: ${({ justify: e }) => e ?? "flex-start"};
    flex-wrap: ${({ wrap: e }) => e ?? "nowrap"};
    ${({ theme: e, gap: t }) => t === void 0 ? "" : `gap: ${typeof t == "number" ? e.spacing(t) : t};`}
    ${({ theme: e, columnGap: t }) => t === void 0 ? "" : `column-gap: ${typeof t == "number" ? e.spacing(t) : t};`}
    ${({ theme: e, rowGap: t }) => t === void 0 ? "" : `row-gap: ${typeof t == "number" ? e.spacing(t) : t};`}
`;
r.displayName = "Flex";
var i = n(t).withConfig({ shouldForwardProp: e })`
    display: ${({ inline: e }) => e ? "inline-flex" : "flex"};
    flex-direction: row;
    align-items: ${({ align: e }) => e ?? "center"};
    justify-content: ${({ justify: e }) => e ?? "flex-start"};
    flex-wrap: ${({ wrap: e }) => e ?? "nowrap"};
    ${({ theme: e, gap: t }) => t === void 0 ? "" : `gap: ${typeof t == "number" ? e.spacing(t) : t};`}
    ${({ theme: e, columnGap: t }) => t === void 0 ? "" : `column-gap: ${typeof t == "number" ? e.spacing(t) : t};`}
    ${({ theme: e, rowGap: t }) => t === void 0 ? "" : `row-gap: ${typeof t == "number" ? e.spacing(t) : t};`}
`;
i.displayName = "Row";
var a = n(t).withConfig({ shouldForwardProp: e })`
    display: ${({ inline: e }) => e ? "inline-flex" : "flex"};
    flex-direction: column;
    align-items: ${({ align: e }) => e ?? "stretch"};
    justify-content: ${({ justify: e }) => e ?? "flex-start"};
    flex-wrap: ${({ wrap: e }) => e ?? "nowrap"};
    ${({ theme: e, gap: t }) => t === void 0 ? "" : `gap: ${typeof t == "number" ? e.spacing(t) : t};`}
    ${({ theme: e, rowGap: t }) => t === void 0 ? "" : `row-gap: ${typeof t == "number" ? e.spacing(t) : t};`}
`;
a.displayName = "Col";
var o = n(t).withConfig({ shouldForwardProp: e })`
    display: ${({ inline: e }) => e ? "inline-flex" : "flex"};
    flex-direction: ${({ direction: e }) => e ?? "row"};
    align-items: center;
    justify-content: center;
    ${({ theme: e, gap: t }) => t === void 0 ? "" : `gap: ${typeof t == "number" ? e.spacing(t) : t};`}
`;
o.displayName = "Center";
//#endregion
export { o as Center, a as Col, r as Flex, i as Row };
